export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";